import React, {Fragment, useState} from 'react'
import DebitPaymentMethod from './Debit'
import CreditCardMethod from './Credit'
import TransferMethod from './Transfer'
import ManualMethod from './Manual'
import {Collapse} from 'reactstrap'
import {Activity, IconArrowRight, ListItem} from '@Knowledge-OTP/znk-ui-components'
import ZelleMethod from './Zelle/zelle'

const PaymentMethod = (props) => {
  const {id, kind, clickable, mutation, loading, className, ...otherProps} = props
  const [isOpen, setOpen] = useState(false)

  return (
    <>
      <div className={`${className}`} onClick={() => (clickable ? setOpen((pre) => !pre) : null)}>
        {kind === 'bankDebit' ? (
          <DebitPaymentMethod {...otherProps} isClickable={clickable} />
        ) : kind === 'creditCard' ? (
          <CreditCardMethod {...otherProps} isClickable={clickable} />
        ) : kind === 'bankCredit' ? (
          <TransferMethod
            {...otherProps}
            accountInfo={otherProps.sourceInfo}
            isClickable={clickable}
          />
        ) : kind === 'manual' ? (
          <ManualMethod
            {...otherProps}
            accountInfo={otherProps?.manualPaymentInfo}
            isClickable={clickable}
          />
        ) : kind === 'zelle' ? (<ZelleMethod {...otherProps} />) : null}
      </div>
      {clickable ? (
        <Collapse isOpen={isOpen}>
          <ListItem
            className='mx-2 px-4'
            hasHover
            onClick={() => mutation(id)}
            Left={null}
            Right={
              <div className='d-flex align-items-center text-secondary'>
                {
                  loading
                  ? <Activity />
                  :
                  (
                    <Fragment>
                      Set as Default
                      <IconArrowRight className='ml-2' />
                    </Fragment>
                  )
                }                
              </div>
            }
          />
        </Collapse>
      ) : null}
    </>
  )
}

export default PaymentMethod
